import React from "react";
import PdfPatientInfo from "../pdfPatientInfo/PdfPatientInfo";
import * as S from "./PdfGenerator.Style";
import { useTranslation } from "react-i18next";

function PdfGenerator({ 
  patientID, 
  onlyDocument, 
  closeModal
}) {

  const { t } = useTranslation("global");

  return (
    <S.PdfGenerator>
      <div className="modal-background" onClick={closeModal}>
      </div>
      <div className="modal-container">
        <div className="header">
          <div className="header__text">
            <div className="header__title">
              {t("globally.downloadPatientsInfo")}
            </div>
            <div className="header__close" onClick={() => closeModal(false)}>
              <i className="header__close-icon icon zaia-icono-cerrar"/>
            </div>
          </div>
        </div>
        <div className="pdf-container">
          <PdfPatientInfo patientID={patientID} onlyDocument={onlyDocument} />
        </div>
      </div>
    </S.PdfGenerator>
  );
}




export default PdfGenerator;